(function () {
    'use strict';

    angular
        .module('agentPortal')
        .factory('messages', messages);

    messages.$inject = ['globalSettingsService'];

    function messages(globalSettingsService) {
        var overrideMessages = {
            '2601': 'Your destination country is not eligible for coverage. Call us at ' + globalSettingsService.vacationRentalPhone() + ' for more details.',
            '2274' : 'Transaction/Premium received date may not be in the future.'
        };

        var service = {
            overrideErrorMessage: overrideErrorMessage
        };
        return service;

        function overrideErrorMessage(errorMessage) {
            var msg = overrideMessages[errorMessage.code];
            // errorMessage.text is our normal error message, errorMessage.message is what comes back on the batch uploader
            return msg || errorMessage.text || errorMessage.message;
        }
    }

})();